import type { ContextSessionResponse } from "@kontextwerk/control-web-client"

/**
 * True while platform staff act through a checked support delegation. The signed-in actor is
 * then the staff identity, never the represented member; the server stays authoritative.
 */
export const isSupportDelegationActive = (
  session: ContextSessionResponse | null | undefined,
): boolean => session?.context.kind === "organization" && Boolean(session.context.delegation)
